import { useParams as useParamsRRD } from "react-router-dom";

export const useParams = <
  T extends string | Record<string, string | undefined>,
>() => {
  return useParamsRRD() as Readonly<Partial<T>>;
};
